import { PcbNodeTypes } from "@buildwithflux/models";
import { pickBy } from "lodash";
import { reparentNode } from "../../nodes";
/**
 * Re-parent route segment nodes.
 *
 * Based on the newly generate nets map, we reparent route segments to
 * corresponding new net nodes
 */
export function reParentSegments(nets, segmentsByTerminal, pcbNodes, netIdLookup) {
    const newNets = Object.entries(nets);
    const viaMap = pickBy(pcbNodes, (n) => n.type === PcbNodeTypes.via);
    // eslint-disable-next-line @buildwithflux/no-array-foreach
    segmentsByTerminal.forEach((adjacentSegmentsForTerminal, terminalId) => {
        const newNetIndexForTerminal = newNets.findIndex(([, terminalIdsInNet]) => {
            return terminalIdsInNet[terminalId];
        });
        if (newNetIndexForTerminal > -1) {
            const newNetHashForSegment = newNets[newNetIndexForTerminal][0];
            const newNetIdForSegment = netIdLookup[newNetHashForSegment];
            // eslint-disable-next-line @buildwithflux/no-array-foreach
            adjacentSegmentsForTerminal.forEach((segment) => {
                reparentNode(pcbNodes, segment, newNetIdForSegment);
                const startVia = viaMap[segment.startId];
                const endVia = viaMap[segment.endId];
                if (startVia) {
                    reparentNode(pcbNodes, startVia, newNetIdForSegment);
                }
                if (endVia) {
                    reparentNode(pcbNodes, endVia, newNetIdForSegment);
                }
            });
        }
    });
}
//# sourceMappingURL=reparentRouteSegments.js.map